import { LocalePlayer } from '../en/player'

const player: LocalePlayer = {
  searchPlayers: '蒐索選手',
  playerProfile: '選手檔案',
  MALE: '男性',
  FEMALE: '女性',
  signUpToSeeInfo: '注册查看球員狀態和比賽歷史',
  loginToSeeInfo: `登入或建立帳戶即可查看該用戶的輸贏記錄、平均贏分、平均搭檔以及對手 DUPR、半衰期、比賽歷史記錄等。`,
  profileUnlock: {
    title: '使用解鎖次數？',
    subtitle: '使用一次免費查看檔案的機會',
    unlock: '解鎖',
    limitReached: '已達上限',
    limitReachedSubtitle: '升級至 DUPR+ 即可無限查看個人檔案',
    upgrade: '升級',
    upgradeLink: '升級解鎖無限',
    viewsLeftShort_one: '剩 {{count}}',
    viewsLeftShort_other: '剩 {{count}}',
    infoTitle: '免費查看檔案',
    info: '您有 {{count}} 次免費查看檔案的機會。',
    resets: '{{when}}重設。',
    banner: {
      viewsLeft_one: '剩餘 {{count}} 次查看',
      viewsLeft_other: '剩餘 {{count}} 次查看',
      runningLow: '您的次數快用完了',
      freeViewsLeft_one: '還剩 {{count}} 次免費查看檔案',
      freeViewsLeft_other: '還剩 {{count}} 次免費查看檔案',
      unlockUnlimited: '解鎖無限查看檔案',
    },
  },
  filterRatingLocked: '升級至 DUPR+ 以按評分篩選',
  ratingLocked: '評分已鎖定',
}

export default player
